import {
  computed,
  inject,
  Signal,
  signal,
  WritableSignal,
} from '@angular/core';
import { ICorporateDesign } from '@web/dtos';
import { CorporateDesignService } from '../../corporate-design/corporate-design.service';
import { SiteContextService } from '../../site-context/site-context.service';

export class MenuSelectionSupportService {
  private readonly corporateDesignService: CorporateDesignService = inject(
    CorporateDesignService
  );
  private readonly siteContextService: SiteContextService =
    inject(SiteContextService);
  private readonly corporateDesign: Signal<ICorporateDesign> = computed(
    this.corporateDesignService.corporateDesign
  );
  private readonly OPACITY_TWENTY_TWO: string = '22';

  public readonly highlightedLinkColor: Signal<string> = computed(() => {
    if (!this.siteContextService.isShopContext()) {
      return '';
    }

    return this.corporateDesignService.primaryFontColor();
  });

  public readonly highlightedLinkBackgroundColor: Signal<string> = computed(() => {
    if (!this.siteContextService.isShopContext()) {
      return '';
    }

    return this.corporateDesignService.primaryColor() + this.OPACITY_TWENTY_TWO;
  });

  public readonly highlightedLink: WritableSignal<number | undefined> = signal(undefined);
}
